<template>
  <main class="container">
      <div class="page measure">
          <section class="page__intro">
            <h1 class="page__title">Förslag på åtgärder</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quis felis elit. Maecenas fermentum ante non ligula tincidunt, eget gravida nulla tempus.</p>
          </section>
          <div class="page__main">
              <div v-for="(item,index) in items" :key="index">
                  <div>
                    <h3>{{item.title}}</h3>
                  </div>
                  <div>
                    <span>Bakgrund</span>
                    <span>{{item.body}}</span>
                  </div>
                  <div>
                      <div></div>
                  </div>
              </div>
          </div>
      </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name:"Measure",
    data(){
        return{
            items:[
                {title:"STARTA SPARANDE I ISK",body:"Ökar pensionen med 17 000 kr/m"},
                {title:"FLYTTA DIN FÖRSÄKRING",body:"Genom att flytta traditionell försäkring från Folksam till Skandia ökar pensionen med 5000 kr/m"},
                {title:"LÄGG TILL PENSIONS-FÖRSÄKRING",body:"Genom att lägga till en pensionsföräkring för 1500 kr ökar pensionen med 4 000 kr/m"},
                {title:"STARTA SPARANDE I ISK",body:"Ökar pensionen med 17 000 kr/m"},
                {title:"LÖNEVÄXLA 25% ÖVER BRYTPUNKT",body:"Ökar pensionen med 2 000 kr/m"}
            ]
        }
    },
    computed: {
        ...mapGetters(['insurances','user'])
    },
    methods: {
        ...mapActions(['getInsurances']),
    },
    created() {
        if(!this.insurances.status){
            this.getInsurances()
        }
    }

}

</script>

